import { UTCDateRange } from '@epicuro-next/ataraxia/models';
import { IFilter } from '@epicuro-next/ataraxia/models';
import { createAction, props } from '@ngrx/store';
import { OrderFilter } from 'graphql-api/baskets-api-interfaces';

import { actionsPrefix } from '../../prefix';

const filterActionsPrefix = `${actionsPrefix}[Filters]`;

export const loadFilters = createAction(`${filterActionsPrefix} Load Filters`);

export const loadFiltersSuccess = createAction(
  `${filterActionsPrefix} Load Filters Success`,
  props<{ total: number; filters: OrderFilter[] }>(),
);

export const loadFiltersFailure = createAction(
  `${filterActionsPrefix} Load Filters Failure`,
  props<{ error: string }>(),
);

export const setInitialSelectedFiltersFromUrl = createAction(
  `${filterActionsPrefix} Set Selected Filters and Search from Url`,
);

export const setInitialSelectedFiltersFromUrlSuccess = createAction(
  `${filterActionsPrefix} Set Selected Filters and Search from Url Success`,
  props<{ filters: IFilter[]; search: string }>(),
);

export const toggleFilter = createAction(
  `${filterActionsPrefix} Toggle OrderFilter`,
  props<{ filter: IFilter }>(),
);

export const clearFilterById = createAction(
  `${filterActionsPrefix} Clear OrderFilter By Id`,
  props<{ fieldId: string }>(),
);

export const changePlacedPeriod = createAction(
  `${filterActionsPrefix} Placed Period Changed`,
  props<{ range?: UTCDateRange }>(),
);

export const setActiveFilters = createAction(
  `${filterActionsPrefix} Set Active Filters`,
  props<{ filters: IFilter[] }>(),
);

export const setSearchQuery = createAction(
  `${filterActionsPrefix} Set Search Query`,
  props<{ search: string }>(),
);

export const resetFiltersState = createAction(
  `${filterActionsPrefix} Reset Filters State`,
);
